// src/core/brand.ts
import { detectTenant } from "./tenant";
import { setAppleTouchIcon, setFavicon } from "./branding";

export type TenantKey = "praxis" | "testcontext";

export type Brand = {
  tenant: TenantKey;
  brandName: string;
  tagline: string;

  faviconHref: string;
  appleTouchIconHref: string;
  logoSrcDay: string;
  logoSrcNight: string;
  logoSrc32: string;

  // optional page assets
  heroImg?: string;
};

export function getBrand(): Brand {
  const t = detectTenant();
  const tenant: TenantKey = t === "testcontext" ? "testcontext" : "praxis";

  if (tenant === "testcontext") {
    return {
      tenant,
      brandName: "TestContext",
      tagline: "Clarity through experimentation and practice",
      faviconHref: "/assets/brand/testcontext-favicon.ico",
      appleTouchIconHref: "/assets/brand/testcontext-touch.png",
      logoSrcDay: "/assets/brand/TestContext-logo-500x200-day.png",
      logoSrcNight: "/assets/brand/TestContext-logo-500x200-night.png",
      logoSrc32: "/assets/brand/TestContext-logo-32.png",
      heroImg: "/assets/hero/testcontext-hero.jpeg",
    };
  }

  return {
    tenant,
    brandName: "Praxis",
    tagline: "Clarity for decisions under pressure",
    faviconHref: "/assets/brand/praxis-favicon.ico",
    appleTouchIconHref: "/assets/brand/praxis-touch.png",
    logoSrcDay: "/assets/brand/Praxis-logo-500x200-day.png",
    logoSrcNight: "/assets/brand/Praxis-logo-500x200-night.png",
    logoSrc32: "/assets/brand/praxis-logo-32.png",
    heroImg: "/assets/hero/praxis-hero.jpeg",
  };
}

export function applyBranding(brand: Brand, pageTitle?: string) {
  const title = pageTitle 
    ? `${brand.brandName} - ${pageTitle}`
    : brand.brandName;
  document.title = title;
  setFavicon(brand.faviconHref);
  setAppleTouchIcon(brand.appleTouchIconHref);
}
